"use client";

import React, { useState } from "react";

type InsertTableGridProps = {
  onSelect: (rows: number, cols: number) => void;
  maxRows?: number;
  maxCols?: number;
  defaultRows?: number;
  defaultCols?: number;
};

const InsertTableGrid: React.FC<InsertTableGridProps> = ({
  onSelect,
  maxRows = 6,
  maxCols = 6,
  defaultRows = 3,
  defaultCols = 3,
}) => {
  const [hoverRows, setHoverRows] = useState<number>(defaultRows);
  const [hoverCols, setHoverCols] = useState<number>(defaultCols);

  return (
    <div className="w-[220px]">
      <div className="mb-2 text-xs text-foreground">
        Size: {hoverCols} × {hoverRows} • Header row enabled
      </div>
      <div className="grid" style={{ gridTemplateColumns: `repeat(${maxCols}, 1fr)`, gap: "4px" }}>
        {Array.from({ length: maxRows }).map((_, r) =>
          Array.from({ length: maxCols }).map((__, c) => {
            const row = r + 1;
            const col = c + 1;
            const active = row <= hoverRows && col <= hoverCols;
            return (
              <button
                key={`${row}-${col}`}
                className={[
                  "h-6 w-6 rounded-sm border",
                  active ? "bg-accent border-ring" : "bg-background border-border",
                  "transition-colors",
                ].join(" ")}
                onMouseEnter={() => {
                  setHoverRows(row);
                  setHoverCols(col);
                }}
                onClick={() => onSelect(row, col)}
                aria-label={`Insert ${row} by ${col} table`}
              />
            );
          })
        )}
      </div>
      <div className="mt-2 text-[10px] text-muted-foreground">
        Tip: Drag column edges inside the table to resize.
      </div>
    </div>
  );
};

export default InsertTableGrid;